import { useState } from 'react';

interface IProps<T> {
  key: string;
  defaultValue: T;
  ttlSeconds: number | null;
}

export function useLocalStorageSynchronizedState<T>({
  key,
  defaultValue,
  ttlSeconds,
}: IProps<T>) {
  const [state, setState] = useState(() => {
    const item = window.localStorage.getItem(key);
    if (item) {
      const data = JSON.parse(item);
      const expirationTime = data.expirationTime;
      if (expirationTime === null || expirationTime > Date.now()) {
        return data.value;
      } else {
        window.localStorage.removeItem(key);
        return defaultValue;
      }
    }
    return defaultValue;
  });

  function handleChange(newValue: T) {
    window.localStorage.setItem(
      key,
      JSON.stringify({
        value: newValue,
        expirationTime: ttlSeconds ? Date.now() + ttlSeconds * 1000 : null,
      })
    );
    setState(newValue);
  }

  return [state, handleChange];
}
